import * as React from 'react';
import styled from "styled-components";
import ErrorPage from '../components/ErrorPage';
import ErrorDescription from '../components/ErrorDescription';

const ErrorImage = styled.img`
    width: 70vw;
    max-width: 426px;
    min-width: 225px;
`

class SomethingWentWrongPage extends React.Component {
  render() {
    return (
      <ErrorPage name="SomethingWentWrong">
        <ErrorDescription title="Something went wrong..." description="Please try again later">
          <ErrorImage src={'https://home-web.azureedge.net/home-web-resources/something-went-wrong-dog.svg'} />
        </ErrorDescription>
      </ErrorPage>
    );
  }
}

export default SomethingWentWrongPage;


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ErrorPages/pages/SomethingWentWrongPage.tsx